import { Component, Injector, OnInit, AfterViewInit } from '@angular/core';
import { LayoutService } from '../../../Services/layout/layout.service';
import { BaseComponent } from '../../base.component';
import { isEmpty, forEach } from 'lodash';

@Component({
	selector: 'headerprogressbar-panel',
	template: `
		<!-- For mobile resolution < 1000px -->

		<!--SIDEBAR ---->
		<div id="sideBarNavBtn" *ngIf="isVisiable">
			<div id="progressBar">
				<div class="progressBarfirst">
					<div [ngStyle]="{ 'width.%': progressValue }" class="progressBarsecond"></div>
				</div>
			</div>

			<div class="sideBarNextStepText">
				<span (click)="sideBarNavBtn($event)" (click)="isshowMyContainer = !isshowMyContainer">
					<img src="assets/images/icons/progress-meter-icon.svg" classname="img-fluid" />
				</span>
				<p class="sideBarStepInd">STEP {{ curntIndex }}/{{ detlLength }}: {{ curntIndexName }}</p>
				<p class="sideBarNextName" *ngIf="curntNexIndex">Next : {{ curntNexIndex }}</p>
			</div>
		</div>
	`,
	styleUrls: ['./headerprogressbar.component.scss'],
})
export class HeaderProgressBarComponent extends BaseComponent implements OnInit {
	model: data;
	globalAttributes: any;
	progressMeter: any;
	details: any;
	curntIndex: any;
	curntNexIndex: any;
	curntIndexName: any;
	detlSection: any;
	detlLength: any;
	progressValue: any;
	sections: section[];
	isshowMyContainer = false;
	isVisiable = false;

	constructor(injector: Injector, private LayoutService: LayoutService) {
		super(injector);
	}
	async ngOnInit() {
		this.LayoutService.staticLayout.subscribe((data) => {
			if (data && data.data && data.data.metadata && data.data.metadata.page && data.data.metadata.page.state) {
				this.model = data.data;
				this.progressMeter = this.model.metadata.progressMeter;
				if (this.model.metadata && this.model.metadata.progressMeter) {
					if (data.data.metadata.progressMeter) {
						this.isVisiable = true;
					}
				}

				this.sections = [];
				if (this.progressMeter) {
					this.addSections(this.progressMeter.sections);
				}
				if (!isEmpty(this.sections)) {
					this.progressBarDetails(this.sections);
				}
			}
		});
	}

	addSections(sections: any[]) {
		forEach(sections, (section) => {
			this.sections.push(section);
			if (this.hasSubStates(section)) {
				this.addSections(section.states);
			}
		});
	}

	hasSubStates(section) {
		return section.states;
	}

	progressBarDetails(progressMeter: any) {
		this.details = progressMeter;
		this.detlSection = this.details;
		this.detlLength = this.details.length;
		let activeSection = null;

		forEach(this.detlSection, (currElement, index) => {
			if (currElement.active) {
				activeSection = {
					i: index,
					currElement,
				};
			}
		});

		if (this.detlLength === activeSection.i + 1) {
			this.curntIndex = activeSection.i + 1;
			this.curntNexIndex = null;
		} else {
			this.curntIndex = activeSection.i + 1;
			this.curntNexIndex = this.detlSection[activeSection.i + 1].title;
		}

		this.curntIndexName = this.detlSection[activeSection.i].title;

		const singleBtnPercentage = 100 / this.detlLength;
		this.progressValue = singleBtnPercentage * (activeSection.i + 1);
	}

	sideBarNavBtn(e) {
		this.observablesService.openSidebar.next(true);
		e.stopPropagation();
	}
}
